module.exports = __webpack_public_path__ + "img/pic04.85a54d00.jpg";